import { RFC } from '@typings/extra-react-router';
import { withRouter } from 'utils/navigation/withRouter';
import { useEnvironment } from 'components/shared/hooks/useEnvironment/useEnvironment';
import { ROUTE_AUTH_LOGIN } from 'config/routes';
import { AuthSsoRoute } from 'config/routes.types';
import { push } from 'utils/navigation/navigate';
import React, { useEffect } from 'react';
import { useStyles } from 'views/Auth/Sso/Sso.styles';

export enum SsoAction {
  LOGIN = 'login',
  LOGOUT = 'logout',
}

const SsoViewComponent: RFC<AuthSsoRoute> = ({ match }) => {
  const classes = useStyles();
  const { oAuth } = useEnvironment();

  const action = match.params.action as SsoAction;

  useEffect(() => {
    if (action === SsoAction.LOGIN) {
      window.location.href = oAuth.loginUrl;
    }
    if (action === SsoAction.LOGOUT) {
      if (oAuth.logoutUrl) {
        window.location.href = oAuth.logoutUrl;
      } else {
        push(ROUTE_AUTH_LOGIN);
      }
    }
  });

  return <div className={classes.wrapper} />;
};

export const SsoView = withRouter(SsoViewComponent);
